import { BASE_URLS } from '@apis/baseUrls';
import { paramsSerializer } from '@apis/paramsSerializer';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { type RootState } from '@store/rootReducer';

const fetchWhitAuth = fetchBaseQuery({
  baseUrl: BASE_URLS.SKELETOR,
  paramsSerializer,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const { credentials } = state.session;
    if (credentials !== undefined) {
      const { accessToken, idToken, impersonationToken } = credentials;
      headers.set('authorization', `Bearer ${accessToken}`);
      headers.set('x-id-token', `${idToken}`);
      if (impersonationToken !== undefined) {
        headers.set('x-impersonation-token', `${impersonationToken}`);
      }

      return headers;
    }
  },
});

export { fetchWhitAuth };
